/**
 * PageHero — the standard dark gradient page header used across the revamped panel.
 * Renders a consistent title + subtitle banner. Drop it at the very top of a page's
 * main content so every screen shares the same header treatment.
 *
 *   <PageHero title='Weight Discrepancy' subtitle='Track and resolve weight disputes' />
 */
import React from 'react'
import {Box, Typography} from '@mui/material'
import {pageHeroSx, heroTitleSx, heroSubSx} from '../styles/patterns'

export default function PageHero({title, subtitle, children, sx}) {
  return (
    <Box sx={{...pageHeroSx, ...sx}}>
      <Typography sx={heroTitleSx}>{title}</Typography>
      {subtitle && <Typography sx={heroSubSx}>{subtitle}</Typography>}
      {children}
    </Box>
  )
}
